module.exports = __webpack_public_path__ + "img/edit-05.64e871b2.svg";